/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DriverPaginationResponseAllOfDataInner
 */
export interface DriverPaginationResponseAllOfDataInner {
    /**
     * ドライバーコード
     * @type {string}
     * @memberof DriverPaginationResponseAllOfDataInner
     */
    driverCode?: string;
    /**
     * グループコード
     * @type {string}
     * @memberof DriverPaginationResponseAllOfDataInner
     */
    companyCode: string;
    /**
     * グループ名
     * @type {string}
     * @memberof DriverPaginationResponseAllOfDataInner
     */
    companyName?: string;
    /**
     * 会社ID
     * @type {string}
     * @memberof DriverPaginationResponseAllOfDataInner
     */
    companyId?: string;
    /**
     * 会社名
     * @type {string}
     * @memberof DriverPaginationResponseAllOfDataInner
     */
    subCompanyName?: string;
    /**
     * 営業所コード
     * @type {string}
     * @memberof DriverPaginationResponseAllOfDataInner
     */
    salesOfficeId?: string;
    /**
     * 営業所名
     * @type {string}
     * @memberof DriverPaginationResponseAllOfDataInner
     */
    salesOfficeName?: string;
    /**
     * ログインID
     * @type {string}
     * @memberof DriverPaginationResponseAllOfDataInner
     */
    loginId: string;
    /**
     * ドライバー名(和名)
     * @type {string}
     * @memberof DriverPaginationResponseAllOfDataInner
     */
    driverName: string;
    /**
     * ドライバー名(英字)
     * @type {string}
     * @memberof DriverPaginationResponseAllOfDataInner
     */
    driverNameEn?: string;
    /**
     * ドライバー名(カナ)
     * @type {string}
     * @memberof DriverPaginationResponseAllOfDataInner
     */
    driverNameYomi?: string;
    /**
     * ドライバー姓
     * @type {string}
     * @memberof DriverPaginationResponseAllOfDataInner
     */
    driverLastName?: string;
    /**
     * ドライバー名
     * @type {string}
     * @memberof DriverPaginationResponseAllOfDataInner
     */
    driverFirstName?: string;
    /**
     * ドライバー姓（カナ）
     * @type {string}
     * @memberof DriverPaginationResponseAllOfDataInner
     */
    driverLastNameKana?: string;
    /**
     * ドライバー名（カナ）
     * @type {string}
     * @memberof DriverPaginationResponseAllOfDataInner
     */
    driverFirstNameKana?: string;
    /**
     * ドライバー姓（英字）
     * @type {string}
     * @memberof DriverPaginationResponseAllOfDataInner
     */
    driverLastNameEn?: string;
    /**
     * ドライバー名（英字）
     * @type {string}
     * @memberof DriverPaginationResponseAllOfDataInner
     */
    driverFirstNameEn?: string;
    /**
     * 性別 (1:男性, 2:女性, 3:指定なし, 4:該当なし)
     * @type {number}
     * @memberof DriverPaginationResponseAllOfDataInner
     */
    gender?: number;
    /**
     * 免許証番号
     * @type {string}
     * @memberof DriverPaginationResponseAllOfDataInner
     */
    licenseNumber?: string;
    /**
     * 免許証有効期限
     * @type {string}
     * @memberof DriverPaginationResponseAllOfDataInner
     */
    licenseExpiry?: string;
    /**
     * 更新日時
     * @type {string}
     * @memberof DriverPaginationResponseAllOfDataInner
     */
    updateTimestamp: string;
    /**
     * 配車可否
     * @type {boolean}
     * @memberof DriverPaginationResponseAllOfDataInner
     */
    available: boolean;
    /**
     * 配車アプリ連携リスト（1:Uber, 2:DiDi）
     * @type {Array<number>}
     * @memberof DriverPaginationResponseAllOfDataInner
     */
    dispatchApps?: Array<number>;
    /**
     * 備考
     * @type {string}
     * @memberof DriverPaginationResponseAllOfDataInner
     */
    description?: string;
    /**
     * 楽観ロック制御用のバージョン番号
     * @type {number}
     * @memberof DriverPaginationResponseAllOfDataInner
     */
    version: number;
}

/**
 * Check if a given object implements the DriverPaginationResponseAllOfDataInner interface.
 */
export function instanceOfDriverPaginationResponseAllOfDataInner(value: object): value is DriverPaginationResponseAllOfDataInner {
    if (!('companyCode' in value) || value['companyCode'] === undefined) return false;
    if (!('loginId' in value) || value['loginId'] === undefined) return false;
    if (!('driverName' in value) || value['driverName'] === undefined) return false;
    if (!('updateTimestamp' in value) || value['updateTimestamp'] === undefined) return false;
    if (!('available' in value) || value['available'] === undefined) return false;
    if (!('version' in value) || value['version'] === undefined) return false;
    return true;
}

export function DriverPaginationResponseAllOfDataInnerFromJSON(json: any): DriverPaginationResponseAllOfDataInner {
    return DriverPaginationResponseAllOfDataInnerFromJSONTyped(json, false);
}

export function DriverPaginationResponseAllOfDataInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): DriverPaginationResponseAllOfDataInner {
    if (json == null) {
        return json;
    }
    return {
        
        'driverCode': json['driver_code'] == null ? undefined : json['driver_code'],
        'companyCode': json['company_code'],
        'companyName': json['company_name'] == null ? undefined : json['company_name'],
        'companyId': json['company_id'] == null ? undefined : json['company_id'],
        'subCompanyName': json['sub_company_name'] == null ? undefined : json['sub_company_name'],
        'salesOfficeId': json['sales_office_id'] == null ? undefined : json['sales_office_id'],
        'salesOfficeName': json['sales_office_name'] == null ? undefined : json['sales_office_name'],
        'loginId': json['login_id'],
        'driverName': json['driver_name'],
        'driverNameEn': json['driver_name_en'] == null ? undefined : json['driver_name_en'],
        'driverNameYomi': json['driver_name_yomi'] == null ? undefined : json['driver_name_yomi'],
        'driverLastName': json['driver_last_name'] == null ? undefined : json['driver_last_name'],
        'driverFirstName': json['driver_first_name'] == null ? undefined : json['driver_first_name'],
        'driverLastNameKana': json['driver_last_name_kana'] == null ? undefined : json['driver_last_name_kana'],
        'driverFirstNameKana': json['driver_first_name_kana'] == null ? undefined : json['driver_first_name_kana'],
        'driverLastNameEn': json['driver_last_name_en'] == null ? undefined : json['driver_last_name_en'],
        'driverFirstNameEn': json['driver_first_name_en'] == null ? undefined : json['driver_first_name_en'],
        'gender': json['gender'] == null ? undefined : json['gender'],
        'licenseNumber': json['license_number'] == null ? undefined : json['license_number'],
        'licenseExpiry': json['license_expiry'] == null ? undefined : json['license_expiry'],
        'updateTimestamp': json['update_timestamp'],
        'available': json['available'],
        'dispatchApps': json['dispatch_apps'] == null ? undefined : json['dispatch_apps'],
        'description': json['description'] == null ? undefined : json['description'],
        'version': json['version'],
    };
}

export function DriverPaginationResponseAllOfDataInnerToJSON(json: any): DriverPaginationResponseAllOfDataInner {
    return DriverPaginationResponseAllOfDataInnerToJSONTyped(json, false);
}

export function DriverPaginationResponseAllOfDataInnerToJSONTyped(value?: DriverPaginationResponseAllOfDataInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'driver_code': value['driverCode'],
        'company_code': value['companyCode'],
        'company_name': value['companyName'],
        'company_id': value['companyId'],
        'sub_company_name': value['subCompanyName'],
        'sales_office_id': value['salesOfficeId'],
        'sales_office_name': value['salesOfficeName'],
        'login_id': value['loginId'],
        'driver_name': value['driverName'],
        'driver_name_en': value['driverNameEn'],
        'driver_name_yomi': value['driverNameYomi'],
        'driver_last_name': value['driverLastName'],
        'driver_first_name': value['driverFirstName'],
        'driver_last_name_kana': value['driverLastNameKana'],
        'driver_first_name_kana': value['driverFirstNameKana'],
        'driver_last_name_en': value['driverLastNameEn'],
        'driver_first_name_en': value['driverFirstNameEn'],
        'gender': value['gender'],
        'license_number': value['licenseNumber'],
        'license_expiry': value['licenseExpiry'],
        'update_timestamp': value['updateTimestamp'],
        'available': value['available'],
        'dispatch_apps': value['dispatchApps'],
        'description': value['description'],
        'version': value['version'],
    };
}

